module.exports = __webpack_public_path__ + "img/Ticket-Star.64a90832.svg";